import { render, staticRenderFns } from "./DivLoader.vue?vue&type=template&id=53cb3cc6"
import script from "./DivLoader.vue?vue&type=script&lang=js"
export * from "./DivLoader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports